import { VForm } from 'vuetify/lib/components/VForm';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('validation-observer',{ref:"observer",attrs:{"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(instance){return [_c(VForm,{ref:_vm.setDirty(instance.dirty),attrs:{"disabled":_vm.disabled},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._t("default",null,null,instance)],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }